import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  navigationButton: {
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
      opacity: 0.6,
    },
  },
  bannerContainer: {
    marginTop: theme.spacing(5),
    backgroundColor: "#262F34",
    overflow: "hidden",
    borderRadius: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  bottomContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    justifyContent: "end",
  },
}));

export default useStyles;
